import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { SectionIdEnum } from '@features/homeB/sections';
import { trackEventWithAtInternet } from '@wizbii/tracking';

export interface ConfigCejOrientationSolutions {
  title: string;
  icon: string;
  color: string;
  fragment: SectionIdEnum;
  trackEventLabel: string;
}

@Component({
  selector: 'app-cej-orientation-solutions',
  templateUrl: './cej-orientation-solutions.component.html',
  styleUrls: ['./cej-orientation-solutions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejOrientationSolutionsComponent {
  readonly configSolutions: ConfigCejOrientationSolutions[] = [
    {
      title: 'Emplois et stage',
      icon: 'luggage-outline',
      color: '#526AB6',
      fragment: SectionIdEnum.jobs,
      trackEventLabel: 'Emploi',
    },
    {
      title: 'Orientation et formation',
      icon: 'compass',
      color: '#975394',
      fragment: SectionIdEnum.trainings,
      trackEventLabel: 'Orientation',
    },
    {
      title: 'Aides et accompagnement',
      icon: 'life-ring',
      color: '#0E7B47',
      fragment: SectionIdEnum.helps,
      trackEventLabel: 'Aides',
    },
    {
      title: 'Engagement et bénévolat',
      icon: 'hand-shake',
      color: '#761B3F',
      fragment: SectionIdEnum.engagment,
      trackEventLabel: 'Engagement',
    },
  ];

  readonly trackEvent = trackEventWithAtInternet;

  @Output() closeEvent = new EventEmitter<void>();

  trackByConfigSolutionTitle(_: number, config: ConfigCejOrientationSolutions): string {
    return config.title;
  }

  close(): void {
    this.closeEvent.emit();
  }
}

@NgModule({
  declarations: [CejOrientationSolutionsComponent],
  exports: [CejOrientationSolutionsComponent],
  imports: [MatIconModule, CommonModule, RouterModule],
})
export class CejOrientationSolutionsModule {}
